import { Checkbox as AriaKitCheckbox } from "ariakit";
import styled from "styled-components";
import { style } from "../style";

const tick = encodeURIComponent(`
  <svg viewBox="0 0 12 9" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M1 5L4 8L11 1" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>`);

const line = encodeURIComponent(
  `<svg viewBox="0 0 12 2" fill="none" xmlns="http://www.w3.org/2000/svg">
     <path d="M1 1L11 1" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
   </svg>`
);

export const LooseCheckboxInput = styled(AriaKitCheckbox)`
  all: unset;

  appearance: none;

  box-sizing: border-box;

  width: 100%;
  height: 100%;
  display: block;

  border-radius: ${style.vars.borderRadius.base};
  border-style: solid;

  border-width: ${style.vars.borderWidth.thin};
  border-color: ${style.colors.grey.primary};

  &:checked,
  &:indeterminate {
    border-color: ${style.colors.blue.dark};
    border-width: ${style.vars.borderWidth.base};
  }

  &:disabled {
    opacity: 0.3;
  }

  &:checked {
    background: url("data:image/svg+xml;charset=utf-8,${tick}") ${style.colors.blue.dark} no-repeat center center;
  }

  &:indeterminate {
    background: url("data:image/svg+xml;charset=utf-8,${line}") ${style.colors.blue.dark} no-repeat center center;
  }

  box-shadow: none;

  :hover:not(:disabled) {
    box-shadow: 0 0 0 2px ${style.colors.blue.primary};
  }
`;

LooseCheckboxInput.displayName = "LooseCheckboxInput";
